/* =========================================================================
   KIIVE AUDIO — v14 motion engine
   Reveal-on-scroll via IntersectionObserver. Zero dependencies.
   - Any element with .kv-reveal or .kv-stagger animates in once on view.
   - Respects prefers-reduced-motion (handled in CSS; we also bail here).
   - Safe to load on every page; no-ops if nothing is tagged.
   ========================================================================= */
(function () {
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function reveal(els) {
    els.forEach(function (el) { el.classList.add("is-in"); });
  }

  function init() {
    var nodes = document.querySelectorAll(".kv-reveal, .kv-stagger");
    if (!nodes.length) return;

    // No IO support or reduced motion → just show everything.
    if (reduce || !("IntersectionObserver" in window)) {
      reveal(Array.prototype.slice.call(nodes));
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });

    nodes.forEach(function (n) { io.observe(n); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-scan when the Shopify theme editor adds/changes a section.
  document.addEventListener("shopify:section:load", init);
})();
